<template>
  <div>
    <div 
      role="status" 
      aria-live="polite" 
      class="sr-only"
    >
      {{ paginationAnnouncement }}
    </div>
  <div v-if="totalPages > 1">
    <ul class="pages">
      <li class="pages__items">
        <a
          :title="$t('common.paging.first')"
          :aria-label="$t('common.paging.first')"
          href="#"
          :class="{ 'btn-disabled': !canViewPreviousPage }"
          :aria-disabled="!canViewPreviousPage"
          class="pages__links"
          @click.prevent="previousPage(1)"
          ><i class="icon-left-chevron-2" aria-hidden="true"></i
        ></a>
      </li>
      <li class="pages__items">
        <a
          :title="$t('common.paging.previous')"
          :aria-label="$t('common.paging.previous')"
          href="#"
          :class="{ 'btn-disabled': !canViewPreviousPage }"
          :aria-disabled="!canViewPreviousPage"
          class="pages__links"
          @click.prevent="previousPage(currentPageNumber - 1)"
          ><i class="icon-left-chevron" aria-hidden="true"></i
        ></a>
      </li>
      <li class="pages__items">
        {{ $t('common.page') }} {{ currentPageNumber }} {{ $t('common.of').toLowerCase() }}
        {{ totalPages }}
      </li>
      <li class="pages__items">
        <a
          :title="$t('common.paging.next')"
          :aria-label="$t('common.paging.next')"
          href="#"
          :class="{ 'btn-disabled': !canViewNextPage }"
          :aria-disabled="!canViewNextPage"
          class="pages__links"
          @click.prevent="nextPage(currentPageNumber + 1)"
          ><i class="icon-right-chevron" aria-hidden="true"></i
        ></a>
      </li>
      <li class="pages__items">
        <a
          :title="$t('common.paging.last')"
          :aria-label="$t('common.paging.last')"
          href="#"
          :class="{ 'btn-disabled': !canViewNextPage }"
          :aria-disabled="!canViewNextPage"
          class="pages__links"
          @click.prevent="nextPage(totalPages)"
          ><i class="icon-right-chevron-2" aria-hidden="true"></i
        ></a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: 'BasePagination',

  props: {
    currentPage: {
      type: [Number, String],
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    totalItems: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      paginationAnnouncement: '', // For pagination update announcements
    };
  },

  computed: {
    currentPageNumber() {
      return +this.currentPage;
    },

    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },

    canViewPreviousPage() {
      return this.currentPageNumber > 1;
    },

    canViewNextPage() {
      return this.currentPageNumber < this.totalPages;
    },
  },

  methods: {
    updatePage(page) {
      if (this.disabled) {
        return;
      }
      this.$emit('update:page', page);
    },

    previousPage(page) {
      if (!this.canViewPreviousPage) {
        return;
      }
      this.updatePage(page);
    },

    nextPage(page) {
      if (!this.canViewNextPage) {
        return;
      }
      this.updatePage(page);
    },

    announcePaginationUpdate() {
      this.paginationAnnouncement = '';
      
      this.$nextTick(() => {
        if (this.totalItems === 0) {
          this.paginationAnnouncement = this.$t('common.paging.noResultsAnnouncement');
        } else {
          this.paginationAnnouncement = this.$t('common.paging.updateAnnouncement', {
            totalItems: this.totalItems,
            currentPage: this.currentPageNumber,
            totalPages: this.totalPages
          });
        }
        
        setTimeout(() => {
          this.paginationAnnouncement = '';
        }, 3000);
      });
    },
  },

  watch: {
    totalItems() {
      this.announcePaginationUpdate();
    },
  },
};
</script>

<style scoped>
.pages {
  float: unset;
  text-align: right;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
</style>
